module.exports = __webpack_public_path__ + "img/menu-hair-1.5b1e4eeb.jpg";